import { createContext } from 'react';

const EmailContext = createContext(null);

export default EmailContext;
